<template>
  <div>
    <div class="right-infp">
      <div class="right-infp-name">
        <el-input placeholder="请输入用户名" ref="account" v-model="form.account" @keyup.native="val => enterinput(val,'password')" type="text"></el-input>
      </div>
      <div class="right-infp-name">
        <el-input placeholder="请输入密码" ref="password" v-model="form.password" @keyup.native="val => enterinput(val)" type="password"></el-input>
      </div>
      <div class="right-infp-btn">
        <button class="btn" @click="handle">登陆</button>
      </div>
      <div class="right-do" @click="goRegister">注册账号</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isLogin: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    // setTimeout(() => {
    // document.getElementsByClassName('el-input__inner')[1].focus();
    // console.log("激活")
    // }, 3000);
  },
  data() {
    return {
      form: {
        account: "",
        password: "",
        shop: "",
      },
    };
  },
  mounted() {
    //this.addEnterListener();
  },
  methods: {
    goRegister() {
      this.$emit("register");
    },
    handle() {
      this.$emit("handle", this.form);
    },
    updateIsLogin(bl){
     // this.isLogin=bl;
    },
	enterinput(event,control){
		if (event.keyCode != undefined) {
			if(event.keyCode==13){
				if(control!=undefined){
					this.$refs[control].focus();
				}else{
					this.handle();
				}
			}
		}
	}
  },
};
</script>